import { Component, EventEmitter, Input, Output, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { CoreDataUpdateService } from 'src/app/data-transfer/services/core-data-update-api-service';
import { EvidenceTypeDto } from 'src/app/data-transfer/core-data/doc/evidence-type-dto';
import { SectionTypeDto } from 'src/app/data-transfer/core-data/doc/section-type-dto';
import { CheckboxFieldTypeDto } from 'src/app/data-transfer/core-data/doc/checkbox-field-type-dto';
import { MatDialog } from '@angular/material/dialog';
import { AddDocDocumentsDialogComponent } from '../../dialogs/add-doc-documents-dialog/add-doc-documents-dialog.component';
import { getDialogConfig } from 'src/app/util/dialog-util';
import { TranslocoService } from '@jsverse/transloco';
import { Subscription } from 'rxjs';
import { DialogActions } from 'src/app/model/dictionary';
import { AreaDto } from 'src/app/data-transfer/core-data/doc/area-dto';
import {  FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { DOCDocumentDto } from 'src/app/data-transfer/core-data/doc/doc-document-dto';
import { SectionDto } from 'src/app/data-transfer/core-data/doc/section-dto';
import { CheckBoxFieldDto } from 'src/app/data-transfer/core-data/doc/checkbox-field-dto';
import { MatTableDataSource } from '@angular/material/table';
import { EvidenceDto } from 'src/app/data-transfer/core-data/doc/evidence-dto';
import { formatDate } from '@angular/common';
import { FileApiService } from 'src/app/data-transfer/services/file-api-service';
import { FileUploadComponent } from '../upload/file-upload/file-upload.component';
import { RadioGroupTypeDto } from 'src/app/data-transfer/core-data/doc/radio-group-type-dto';
import { RadioGroupDto } from 'src/app/data-transfer/core-data/doc/radio-group-dto';

class PendingDocument {
  file!: File|null;
  docDocument!: DOCDocumentDto;
  sectionId!: string;
}

@Component({
  selector: 'app-doc-upload-section',
  templateUrl: './doc-upload-section.component.html',
  styleUrl: './doc-upload-section.component.scss'
})
export class DocUploadSectionComponent extends FileUploadComponent implements OnInit, OnDestroy {
  @Input()
    get isEditable(): boolean {
            return this._isEditable;
          }
    set isEditable(newValue: boolean) {
      this._isEditable = newValue;
      this.changeEdit();
    }
  @Input()
    get areaDto(): AreaDto {
          return this._areaDto;
        }
    set areaDto(newValue: AreaDto) {
      if(newValue != null) {
        this._areaDto = newValue;
        this.updateDocumentControlls();
        if(this._isEditable) {
          this.areaDtoChange.emit(newValue);
        }
      }
    }
  @Output() areaDtoChange = new EventEmitter();
  @Output() newDocumentPending = new EventEmitter();

  get data(): Map<string,Map<number,MatTableDataSource<EvidenceDto>>> {
      return this.getTableData();
  }
   columnNames = ['name','evidences', 'testResult', 'validityPeriod', 'actions'];
   columnNamesReduced = ['name','actions'];
   protected possibleEvidences = new Map<string, EvidenceTypeDto>();
   protected possibleCheckboxes = new Map<string, CheckboxFieldTypeDto>();
   protected possibleSections : SectionTypeDto[] = [];
   protected possibleRadioGroups = new Map<string, RadioGroupTypeDto>();
   protected dialogSubscription?: Subscription;
   private _areaDto: AreaDto = new AreaDto();
   protected documentPrefix = 'document_';
   protected checkboxPrefix = 'checkbox_';
   protected radioGroupPrefix = 'radiogroup_';
   areaFormGroup!: FormGroup;
   private pendingDocuments: PendingDocument[] = [];
   private idSubscription?: Subscription;
   private _isEditable = true;

   constructor(protected coreDataUpdateService: CoreDataUpdateService,
              protected dialog: MatDialog,
              protected translateService: TranslocoService,
              protected formBuilder: FormBuilder,
              protected fileApiService: FileApiService,
   ) {
      super(dialog);
      this.possibleEvidences = coreDataUpdateService.allDOCEvidenceTypesMap;
      this.possibleCheckboxes = coreDataUpdateService.allDOCCheckboxFieldTypesMap;
      this.possibleSections = coreDataUpdateService.allDOCSectionTypes;
      this.possibleRadioGroups = coreDataUpdateService.allDOCRadioGroupTypesMap
   }

   ngOnInit() {
    const formObject = {};
    for(const section of this.possibleSections) {
      const sectionDto : SectionDto= this.getSection(section.id);
      for(const checkboxid of section.possibleCheckboxFields) {
        const checkboxDto : CheckBoxFieldDto = this.getcheckbox(sectionDto,checkboxid);
        (formObject as any )[this.checkboxPrefix+section.id+'_'+ checkboxid] = [checkboxDto.fieldValue,[]];
      }

      for(const radiogroupId of section.possibleRadioGroups) {
        const radioGroup : RadioGroupDto = this.getRadiogroup(sectionDto,radiogroupId);
        (formObject as any )[this.radioGroupPrefix+section.id+'_'+ radiogroupId] = [radioGroup.value,[]];
      }

    }
    this.areaFormGroup = this.formBuilder.group(formObject);
    this.changeEdit();
    this.updateDocumentControlls();
  }

   getTableData() : Map<string,Map<number,MatTableDataSource<EvidenceDto>>> {
    const map: Map<string,Map<number,MatTableDataSource<EvidenceDto>>> = new Map<string,Map<number,MatTableDataSource<EvidenceDto>>>();
    for(const section of this.areaDto.sections) {
      const documentMap = new Map<number,MatTableDataSource<EvidenceDto>>();
      map.set(section.sectionType, documentMap);
      for(const document of section.documents) {
        const documenDataSource :MatTableDataSource<EvidenceDto> = new MatTableDataSource<EvidenceDto>();
        documentMap.set(document.index,documenDataSource);
        for(const evidence of document.linkedEvidences) {
          documenDataSource.data.push(evidence);
        }
      }
    }
    return map;
   }

    protected getSection(sectionId:string): SectionDto {
      const section: SectionDto|undefined = this.areaDto.sections.find(x => x.sectionType === sectionId);
      if(section) {
        return section;
      }
      const newSection : SectionDto = {
        sectionType: sectionId,
        documents: [],
        checkboxFields: [],
        radioGroups: [],
      };
      this.areaDto.sections.push(newSection);
      return newSection;
    }

    protected getcheckbox(section:SectionDto, checkboxId: string): CheckBoxFieldDto {
      const checkbox: CheckBoxFieldDto|undefined = section.checkboxFields.find(x => x.fieldType === checkboxId);
      if(checkbox) {
        return checkbox;
      }
      const newCheckbox : CheckBoxFieldDto = {
        fieldType: checkboxId,
        fieldValue: false,
      };
      section.checkboxFields.push(newCheckbox);
      return newCheckbox;
    }

    updateCheckbox(sectionid:string,checkboxid:string){
      if(this._isEditable) {
        const currentSection: SectionDto = this.getSection(sectionid);
        const checkbox: CheckBoxFieldDto = this.getcheckbox(currentSection, checkboxid);
        checkbox.fieldValue = this.areaFormGroup.value[this.checkboxPrefix+sectionid+'_'+ checkboxid];
        this.areaDtoChange.emit(this.areaDto);
      }
    }

    protected getRadiogroup(section:SectionDto, radiogroupId: string): RadioGroupDto {
      const radiogroup: RadioGroupDto|undefined = section.radioGroups.find(x => x.radioGroupType === radiogroupId);
      if(radiogroup) {
        return radiogroup;
      }
      const newRadioBox : RadioGroupDto = {
        radioGroupType: radiogroupId,
        value: undefined,
      };
      section.radioGroups.push(newRadioBox);
      return newRadioBox;
    }

    updateRadiogroup(sectionid:string,radiogroupId:string, newValue:string){
      if(this._isEditable) {
        const currentSection: SectionDto = this.getSection(sectionid);
        const radiogroup: RadioGroupDto = this.getRadiogroup(currentSection, radiogroupId);
        radiogroup.value = newValue;
        this.areaDtoChange.emit(this.areaDto);
      }
    }

    radioButtonClicked(sectionid:string,radiogroupId:string, newValue:string) {
      if(this._isEditable) {
        const currentSection: SectionDto = this.getSection(sectionid);
        const radiogroup: RadioGroupDto = this.getRadiogroup(currentSection, radiogroupId);
        if(radiogroup.value == newValue) {
          this.areaFormGroup.value[this.radioGroupPrefix+sectionid+'_'+ radiogroupId] = undefined;
          radiogroup.value = undefined;
          this.areaFormGroup.controls[this.radioGroupPrefix+sectionid+'_'+ radiogroupId]?.reset();
          this.areaDtoChange.emit(this.areaDto);
        }
      }
    }


    getDateRangeLable(start:string, end:string): string {
      if(start || end) {
        return this.formatDateToLabel(start) + ' - ' + this.formatDateToLabel(end)
      }
      return '';
    }

    formatDateToLabel(date:string) : string {
      if(date) {
        return formatDate(date,'YYYY.MM.dd','en')
      }
      return date
    }

    deleteEvidence(sectionid:string,documentindex: number) {
      if(this._isEditable){
        const section : SectionDto = this.getSection(sectionid);
        const index = section.documents.findIndex(x => x.index === documentindex);
        if(index >= 0) {
          this.removePendingDocument(sectionid,documentindex)
          section.documents.splice(index,1);
          section.documents.forEach((item) => {
            if(item.index > index) {
              item.index --;
            }
          })
          this.updateDocumentControlls();
          this.areaDtoChange.emit(this.areaDto);
        }
      }
    }
    updateDocumentControlls() {
      if(this.areaFormGroup) {
        for(const key of Object.keys(this.areaFormGroup)){
          if( key.startsWith(this.documentPrefix)){
            this.areaFormGroup.removeControl(key);
          }
        }
        if(this._areaDto&&this._areaDto.sections){
          for(const section of this._areaDto.sections){
            if(section.documents){
              for( const docDocument of section.documents) {
                if(docDocument.comment && docDocument.comment.trim().length>0) {
                  const key = this.documentPrefix+ section.sectionType + docDocument.index;
                  this.areaFormGroup.addControl(key,new FormControl({value: docDocument.comment, disabled: true},[]));
                }
              }
            }
          }
        }
      }
    }

    private removePendingDocument(sectionId:string,documentIndex:number) {
      const index = this.pendingDocuments.findIndex(x => x.sectionId == sectionId && x.docDocument.index == documentIndex);
      if(index && index >0) {
          this.pendingDocuments.splice(index,1);
      }
    }

    onViewDocumentClick(sectionId: string, document: DOCDocumentDto) {
      let pdfUrl: string;
      const doc :PendingDocument|undefined = this.getPendingDocument(sectionId,document.index);
      if (doc) {
        const file = doc.file;
        if (!file) { return; }
        pdfUrl = window.URL.createObjectURL(file);
        window.open(pdfUrl, '_blank');
      } else {
        this.idSubscription = this.fileApiService.getPdfById(document.documentId).subscribe(file => {
          pdfUrl = window.URL.createObjectURL(file);
          window.open(pdfUrl, '_blank');
        });
      }
    }

    private getPendingDocument(sectionId:string,documentIndex:number):PendingDocument|undefined {
      return this.pendingDocuments.find(x => x.sectionId == sectionId && x.docDocument.index == documentIndex)
    }

    getSubtitle(sectionid:string){
      //check for generalSection
      if(sectionid === '981048eb-9362-4de9-83d8-05a2c280727f') {
        return this.translateService.translate('docDocuments.subtitles.generalSection')
      }
      return this.translateService.translate('docDocuments.subtitles.common')
    }

    getDownloadtitle(sectionid:string){
      //check for generalSection
      if(sectionid === '981048eb-9362-4de9-83d8-05a2c280727f') {
        return this.translateService.translate('docDocuments.uploadFile')
      }
      return this.translateService.translate('docDocuments.uploadEvidences')
    }

    getDisplayClass(sectionId:string, columnName:string):string{
      if(this.skipAdditionalInformations(sectionId,columnName)) {
        return 'none';
      }
      return '';
    }

    skipAdditionalInformations(sectionId:string, columnName:string):boolean{
      return this.getColumnNames(sectionId).find(x=> x===columnName) === undefined;
    }

    opendialog(section:SectionTypeDto) {
      if(this._isEditable) {
        const dialogConfig = getDialogConfig(section,'1200px');
        const dialogRef = this.dialog.open(AddDocDocumentsDialogComponent, dialogConfig);

        this.dialogSubscription = dialogRef.afterClosed().subscribe(dialogResult => {
          if (dialogResult.event === DialogActions.REJECT) { return; }
          const currentSection: SectionDto = this.getSection(section.id);
          dialogResult.data.document.index = currentSection.documents.length;
          currentSection.documents.push(dialogResult.data.document);
          this.pendingDocuments.push({
            docDocument: dialogResult.data.document,
            file: dialogResult.data.file,
            sectionId: section.id
          })
            this.updateDocumentControlls();
            this.areaDtoChange.emit(this.areaDto);
        });
      }
    }

    ngOnDestroy(): void {
      this.idSubscription?.unsubscribe();
      this.dialogSubscription?.unsubscribe();
    }

    changeEdit(): void {
      if(this.areaFormGroup) {
        Object.keys(this.areaFormGroup.controls).forEach(key => {
          if(this._isEditable) {
            this.areaFormGroup.controls[key].enable()
          } else {
            this.areaFormGroup.controls[key].disable()
          }

        })
      }
    }

    public getDocumentFormData() {
      const fileList: File[] = []
      for( const file of this.pendingDocuments) {
        if(file.file){
          fileList.push(file.file)
        }
      }
      return super.getNewFilesFormData(fileList, 'files');
    }

    protected getColumnNames(sectionId: string):string[] {
      //check for generalSection
      if(sectionId === '981048eb-9362-4de9-83d8-05a2c280727f') {
        return this.columnNamesReduced;
      }
      return this.columnNames;
    }

    updateDOCDocumentsAfterSaving(docList: number[]): void {
      for (let index = 0; index < docList.length; index++) {
        if (this.pendingDocuments[index]) {
            this.pendingDocuments[index].docDocument.documentId = docList[index];
        }
      }
    }
  }
